import React from "react";
import { connect } from "react-redux";
import {
  FormSection,
  Field,
  reduxForm,
  change,
  getFormValues,
} from "redux-form";
import _ from "lodash";

import Input from "components/Input";
import Select from "components/Select";
import BackgroundBlock from "../../partials/BackgroundBlock";
import ButtonsRow from "../../partials/ButtonsRow";
import CommentBlock from "../../partials/Comment";
import Validations from "helpers/validations";

import "./style.scss";

interface IProps {
  invalid: boolean;
  changeField: (fieldname: string, value: any) => void;
  goNext: () => void;
  goBack: () => void;
  settings: any;
  formValues: any;
  freightCosts: any[];
}

class StepThree extends React.Component<IProps> {
  public componentDidMount() {
    const {
      formValues: { transport },
      settings,
      changeField,
      freightCosts,
    } = this.props;

    if (!transport) {
      const franking = _.get(settings, "Settings.franking");
      changeField(
        "transport.freightCosts",
        franking
          ? freightCosts.find((f) => f.value === (franking.value || franking))
          : freightCosts.find((f) => f.value === "Franco")
      );
      changeField(
        "transport.transporter",
        _.get(settings, "Settings.transporter", "")
      );
      changeField(
        "transport.cityShipment",
        _.get(settings, "Settings.deliveryFrom", "")
      );
    }
  }

  public render() {
    const { goNext, goBack, invalid, freightCosts } = this.props;

    return (
      <div id="step-three">
        <FormSection name="transport" component={BackgroundBlock}>
          <div className="step-three-row">
            <Field
              containerClassName="form-field"
              className="min-width-select-forms"
              name="freightCosts"
              label="DELIVERIES_REQUIREMENTS"
              component={Select}
              options={freightCosts}
              validate={[Validations.required]}
            />
            <Field
              containerClassName="form-field"
              name="transporter"
              label="DELIVERIES_TRANSPORTER"
              component={Input}
              validate={[Validations.maxLength(50)]}
            />
            <Field
              containerClassName="form-field"
              name="cityShipment"
              label="DELIVERIES_CITY"
              component={Input}
              validate={[Validations.maxLength(35)]}
            />
          </div>
          <Field name="comment" component={CommentBlock} maxLength={250} />
        </FormSection>
        <ButtonsRow
          goNext={goNext}
          goBack={goBack}
          showBackBtn
          disabled={invalid}
        />
      </div>
    );
  }
}

const StepThreeWithReduxForm = reduxForm({
  form: "delivery",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(StepThree);

export default connect(
  (state) => ({
    settings: state.preferences.settings,
    formValues: getFormValues("delivery")(state),
    freightCosts: state.preferences.freightCosts,
  }),
  {
    changeField: (fieldName, value) => change("delivery", fieldName, value),
  }
)(StepThreeWithReduxForm);
